import request from "@/utils/request";
import { CreateMailRequest } from "@/views/mail-management/MailManagement.vue";

export const searchUserMails = (params: any) =>
    request({
        url: "/mails",
        method: "get",
        params
    });
export const searchHeadUserMails = (params) =>
  request({
    url: "/mails/new-mails",
    method: "get",
    params
  });

export const updateMailAlreadyRead = (data: any) =>
  request({
    url: `/mails/all-ready`,
    method: "put",
    data: data,
  });

export const markedAsAlreadyReadOfUserAllMail = () =>
    request({
        url: `/mails/all-marked-is-to-read`,
        method: "put"
    });

export const getRecipients = (params: any) =>
  request({
    url: "/mails/recipient",
    method: "get",
    params,
  });

export const searchDocumentCodes = (params: any) =>
  request({
    url: "/mails/documents",
    method: "get",
    params,
  });

export const uploadAppendix = (data: FormData) =>
  request({
    headers: { "Content-Type": "multipart/form-data" },
    url: "/mails/appendix",
    method: "post",
    data: data,
  });

export const sendMail = (data: any) =>
  request({
    url: "/mails",
    method: "post",
    data: data,
  });

export const updateSystemMailUsers = (data: any) =>
  request({
    url: "/mails/system-mail-users",
    method: "put",
    data: data,
  });

export const getSystemMailConfiguration = () =>
  request({
    url: "/mails/system-mail-configuration",
    method: "get",
  });

export const getSystemMailUsers = (params: any) =>
  request({
    url: "/mails/system-mail-users",
    method: "get",
    params,
  });

export const confirmComplete = (id: string) =>
  request({
    url: `/mails/user-mail-map/${id}`,
    method: "PUT",
  });

export const updatePushMessage = (id: string, data: any) =>
  request({
    url: `/mails/system-mail-configuration/${id}/push-message`,
    method: "put",
    data: data,
  });

export const updateCompleted = (id: string, data: any) =>
  request({
    url: `/mails/system-mail-configuration/${id}/completed`,
    method: "put",
    data: data,
  });

export const addComment = (id: string, params: any) =>
  request({
    url: `/mails/${id}/comments`,
    method: "put",
    params,
  });

export const deleteMailMessage = (id: string) =>
  request({
    url: `/mails/${id}`,
    method: "delete",
  });

export const updateTemplate = (id: string, data: any) =>
  request({
    url: `/mails/system-mail-configuration/${id}/template`,
    method: "put",
    data: data,
  });

export const queryMailCompletedStatus = (id: string) =>
  request({
    url: `/mails/${id}/completed-status`,
    method: "GET",
  });

// /mails/document-types
export const getDocumentTypes = () =>
  request({
    url: `/mails/document-types`,
    method: "GET",
  });

export const editor = (type: any) =>
  request({
    url: `/mails/template-description`,
    method: "GET",
    params: { type: type },
  });

  // /mails/new-mails/user-mail 新消息
  export const getUserMail = (params) =>
    request({
      url: `/mails/new-mails/user-mail`,
      method: "GET",
      params
    });
  // /mails/new-mails/system-mail 系统消息
  export const getSystemMail = (params) =>
    request({
      url: `/mails/new-mails/system-mail`,
      method: "GET",
      params
    });